/* eslint-disable no-use-before-define */
import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { getAccessToken } from "../../../utils/oauth";
import { AppConfig } from "../../../configs/admin-config";

const useStyles = makeStyles()((theme) => ({
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function CountrySelect(props) {
  const { classes } = useStyles();
  const [countries, setCountries] = useState([]);

  const truncateText = (text, maxLength = 23) => {
    if (!text) return '';
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  const getCountriesList = async () => {
    const requestURL = AppConfig.baseUrl + AppConfig.countries;

    try {
      let response = await fetch(requestURL, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      let data = await response.json();

      if (response.status === 200 && data.length > 0) {
        setCountries(data);
      } else {
        console.warn("No countries retrieved");
      }
    } catch (error) {
      console.error("Failed to fetch countries: ", error);
    }
  };

  useEffect(() => {
    getCountriesList();
  }, []);

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel id="country-select-label">Country</InputLabel>
      <Select
        labelId="country-select-label"
        id="country-select"
        label="Country"
        value={props.country}
        onChange={props.handleChange}
        renderValue={(selected) => {
          const country = countries.find(c => c.countryId === selected);
          return country ? truncateText(country.countryName) : '';
        }}
      >
        {countries.map((country) => (
          <MenuItem key={country.countryId} value={country.countryId}>
            {country.countryName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
